<div class="text">
    <section class="pb-0 faqAnchor" id="faq">
        <div class="container">
            <div class="row">
                <!-- <div class="col-12">
                    <h2>Frequently Asked Questions</h2>
                    <p class="dxcfaqsubtitle">Here you can find answers to common questions and queries</p>
                </div> -->
                <div class="classStyle">
                    <div>
                        <h1 [class]="item.isClicked ? 'fontClicked':''" class="classContentStyles borderStyle" *ngFor="let item of this.faqItems" (click)="selectClass(item)">{{item.classname}}</h1>
                    </div>
                </div>
                <div class="col-12" style="padding-top: 15px;">
                    <!-- accordion -->
                  
                    <div id="accordion">
                        <p class="dxcfaqcatsubtitle">The following topics are available, clicking on them will take you to the section further down the page</p>
                        <div style="width: 100%;">
                        <div class="dxcfaqcatli" *ngFor="let item of this.selectedItems">
                            <a [attr.href]="'faq#'+item.groupname" [id]="'Group' + item.groupname" target="_self" class="borderStyle" (click)="selectGroup(item)" [class]="item.isClicked ? 'selectedGroupUp':''">
                               <span class="selectedItemWidth">{{item.groupname}}<fa-icon icon="arrow-circle-down" style="margin-left: 5px;"></fa-icon></span>
                            </a>
                        </div>
                        </div>
                        <div *ngFor="let item of this.faqItems">
                            <div *ngIf="item['showTopics'] && item['isClicked']" class="hottopics">
                                    <h1 class="topics">HOT TOPICS</h1>
                                    <mat-accordion>
                                        <ng-container *ngFor="let item of this.hotTopics">
                                            <mat-expansion-panel *ngIf="item.question" class="topicStyle borderStyle" hideToggle #mep="matExpansionPanel">
                                                <mat-expansion-panel-header class="card-header" *ngIf="item.question">
                                                    <mat-panel-title class="h4">
                                                        {{ item.classname=="Release Notes"?item.groupname:item.question }}
                                                    </mat-panel-title>
                                                    <mat-panel-description>
                                                        <mat-icon>{{mep.expanded ? "remove" : "add"}}</mat-icon>
                                                        </mat-panel-description>
                                                </mat-expansion-panel-header>
                                                <div class="card-body dxcfaqcard" *ngIf="item.question">
                                                    <span [innerHTML]="item.classname=='Release Notes'? item.question+item.answer:item.answer"></span>      
                                                </div>
                                            </mat-expansion-panel>
                                        </ng-container>
                                    </mat-accordion>
                            </div>
                        </div>
                    <div>
                        <div *ngFor="let item of this.selectedItems">
                            <span class="dxcfaqcatspan" *ngIf="item.c[0].question != null" [class]="item.isClicked ? 'borderStyle selectedGroupUp selectedGroupBottom':''">
                                <a [id]="item.groupname">
                                    <h3 class="dxcfaqcattitle">{{item.groupname}}</h3>
                                </a><a href="faq#faq" title="back to top" style="margin-bottom: 5px;font-size: 14px;">
                                    <fa-icon icon="arrow-circle-up"></fa-icon>
                                </a>
                            </span>
    
                            <mat-accordion *ngIf="item.c[0].question != null">
                                <mat-expansion-panel *ngFor="let q of item.c" [class]="q.question ?'borderStyle':''" class="mb-3 cardStyle" [expanded]="q.isOpen" hideToggle #mep1="matExpansionPanel">
                                    <mat-expansion-panel-header class="card-header" *ngIf="q.question">
                                        <mat-panel-title class="faqQuestionTitle h4">
                                            {{ q.question }}
                                        </mat-panel-title>
                                        <mat-panel-description>
                                            <mat-icon>{{mep1.expanded ? "remove" : "add"}}</mat-icon>
                                        </mat-panel-description>
                                    </mat-expansion-panel-header>
                                    <div class="card-body dxcfaqcard" *ngIf="q.question">
                                        <div *ngIf="q.answer">
                                            <span [innerHTML]="q.answer"></span>
                                        </div>
                                    </div>
                                </mat-expansion-panel>
                            </mat-accordion>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>
